export default {
    setSubscriptionPlan: (state, planNumber: number) => {
      state.subscriptionPlan = planNumber;
    },
}